import css from 'styled-jsx/css';
import { display, pageWidth } from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE } from 'constants/mq';

export default css`
  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  @media (min-width: 48rem) {
    .Spread__item--0,
    .Spread__item--ad {
      flex: 0 0 100%;
    }

    .Spread__items {
      flex-wrap: wrap;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) and (max-width: 63.99rem) {
      .Spread__item--0 {
        padding: 0 1.5rem;
      }
    }

    @media (min-width: 64em) {
      .Spread--everyday {
        position: relative;
        display: flex;
        flex-direction: column;
      }

      .Spread__description,
      .Spread__title {
        align-self: stretch;
        margin: 0 1.5rem 1.5rem calc((100% - ${pageWidth.large}) / 2);
        max-width: ${pageWidth.large};
      }

      .Spread__item--0 {
        grid-column-start: 2;
        width: 100%;
      }

      .Spread__item--ad {
        grid-column: span 3;
      }

      .Spread__items {
        grid-template-columns:
          calc((100vw - ${pageWidth.large}) / 2)
          minmax(calc((${pageWidth.large} * 0.58) - 1.5rem), ${pageWidth.large})
          minmax(0, calc((100vw - ${pageWidth.large}) / 2));
        width: 100%;
        padding: 0;
      }
    }

    @media (min-width: 75rem) {
      .Spread__description,
      .Spread__title {
        margin: 0 1.5rem 1.5rem calc((100% - ${pageWidth.midlarge}) / 2);
        max-width: ${pageWidth.midlarge};
      }

      .Spread__items {
        grid-template-columns:
          calc((100vw - ${pageWidth.midlarge}) / 2)
          minmax(
            calc((${pageWidth.midlarge} * 0.58) - 1.5rem),
            ${pageWidth.midlarge}
          )
          minmax(0, calc((100vw - ${pageWidth.midlarge}) / 2));
      }
    }
  }

  /* CLEANUP Special divider for Cubby */
  :global(.cb) .Spread--everyday {
    grid-template:
      'title'
      'description'
      'items'
      'divider'
      / 1fr;
  }

  :global(.cb) .Spread--everyday::after {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 92 26'%3E%3Ccircle cx='13' cy='13' r='13' fill='%23f15d29'/%3E%3Cpath fill='%23fbcb11' d='M33 0h26v26H33z'/%3E%3Cpath d='M66 0h26v26L66 0z' fill='%23bca3bf'/%3E%3C/svg%3E");
    grid-area: divider;
    justify-self: center;
    height: 19.5px;
    width: 69px;
  }

  :global(.cb) .Spread--everyday .Spread__title {
    position: relative;
    margin: 0 0 1rem;
    justify-content: center;
    border-bottom: none;
    height: 44px;
    padding: 0 1.5rem;
  }

  :global(.cb) .Spread--everyday .Spread__title h4 {
    font-family: ${display};
    font-size: var(--fontScale5);
    text-align: center;
    text-transform: lowercase;
  }

  @media screen and ${MQ_MEDIUM} {
    :global(.cb) .Spread--everyday .Spread__title {
      margin-bottom: 1rem;
      height: 50px;
    }

    :global(.cb) .Spread--everyday .Spread__title h4 {
      font-size: var(--fontScale6);
    }
  }

  @media screen and ${MQ_LARGE} {
    :global(.cb) .Spread--everyday {
      display: grid;
      grid-template:
        '....... title       .......'
        '.....   description .......'
        'items   items       items'
        'divider divider     divider'
        / 1fr 976px 1fr;
    }

    :global(.cb) .Spread--everyday::after {
      height: 26px;
      width: 92px;
    }

    :global(.cb) .Spread--everyday .Spread__title {
      margin-bottom: 1rem;
      height: 54px;
      padding: 0;
    }

    :global(.cb) .Spread--everyday .Spread__title h4 {
      font-size: var(--fontScale5);
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    :global(.cb) .Spread--everyday {
      grid-template-columns: 1fr 1148px 1fr;
    }
  }
`;
